import { c as _c } from "react/compiler-runtime";
import { DiscountTypeInterface } from 'modules/coupons/types/coupon-interface';
import { PillRadioGroup } from 'shared/components/pill-radio-group';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
type DiscountTypeId = DiscountTypeInterface['id'];
interface DiscountTypeSelectorProps {
  disabled?: boolean;
  onChange: (value: DiscountTypeId) => void;
  value: DiscountTypeId;
}
function DiscountTypeSelector(t0) {
  const $ = _c(16);
  const {
    disabled,
    onChange,
    value
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.coupon.discount.percent");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      id: "percent",
      caption: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("dashboard.coupon.discount.fixed");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      id: "fixed",
      caption: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = [t2, t4];
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const options = t5;
  let t6;
  if ($[11] !== disabled || $[12] !== onChange || $[13] !== options || $[14] !== value) {
    t6 = <PillRadioGroup options={options} onChange={onChange} value={value} disabled={disabled} />;
    $[11] = disabled;
    $[12] = onChange;
    $[13] = options;
    $[14] = value;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
export { DiscountTypeSelector };
export type { DiscountTypeSelectorProps };